import React, {useState} from "react"
import {Project} from "./types"

// Category colours for letter-avatars; leads with the Bellissimo brand green.
const PALETTE = [
    "#016f4d", "#e05c2e", "#2ea877", "#9b59b6", "#e67e22",
    "#16a085", "#c0392b", "#2980b9", "#8e44ad", "#27ae60",
]

interface Props {
    project: Project
    index: number
}

const ProjectAppIcon: React.FC<Props> = ({project, index}) => {
    const bg = PALETTE[index % PALETTE.length]
    const [imgFailed, setImgFailed] = useState(false)

    const showImage = project.picture_url && !imgFailed

    return (
        <div
            style={{
                width: 40,
                height: 40,
                minWidth: 40,
                borderRadius: 8,
                overflow: "hidden",
                // Keep white behind loaded images so transparent PNGs don't bleed the palette colour.
                background: showImage ? "#fff" : bg,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            {showImage ? (
                <img
                    src={project.picture_url}
                    alt={project.title}
                    onError={() => setImgFailed(true)}
                    style={{width: "100%", height: "100%", objectFit: "cover", display: "block"}}
                />
            ) : (
                <span style={{color: "#fff", fontSize: 18, fontWeight: 600, userSelect: "none"}}>
                    {project.title.charAt(0).toUpperCase()}
                </span>
            )}
        </div>
    )
}

export default ProjectAppIcon
